const SCHEDINA = {
  bozza: ["Bozza", "bg-amber-50 text-amber-800 border-amber-200"],
  confermata: ["Confermata", "bg-sky-50 text-sky-800 border-sky-200"],
  validata: ["Validata", "bg-indigo-50 text-indigo-800 border-indigo-200"],
  inviata: ["Inviata", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  ricevuta: ["Ricevuta archiviata", "bg-teal-50 text-teal-800 border-teal-200"],
  errore: ["Errore", "bg-rose-50 text-rose-800 border-rose-200"],
};
const BOOKING = {
  attesa: ["In attesa dati", "bg-amber-50 text-amber-800 border-amber-200"],
  compilato: ["Da confermare", "bg-sky-50 text-sky-800 border-sky-200"],
  confermato: ["Check-in confermato", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  cancellata: ["Cancellata", "bg-stone-100 text-stone-600 border-stone-200"],
};
const MONTH = {
  da_completare: ["Da completare", "bg-rose-100 text-rose-900 border-rose-300"],
  pronto: ["Pronto per export", "bg-amber-100 text-amber-900 border-amber-300"],
  esportato: ["Esportato", "bg-sky-100 text-sky-900 border-sky-300"],
  trasmesso: ["Trasmesso", "bg-emerald-100 text-emerald-900 border-emerald-300"],
};
const MAPS = { schedina: SCHEDINA, booking: BOOKING, month: MONTH };

export function StatusBadge({ kind = "schedina", status, testId }) {
  const [label, cls] = MAPS[kind][status] || [status || "-", "bg-stone-100 text-stone-700 border-stone-200"];
  return (
    <span data-testid={testId || `status-${kind}-${status}`} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${cls}`}>
      {label}
    </span>
  );
}
